import Swal from "sweetalert2";

/**
 * Show a SweetAlert2 modal with custom message
 * @param {Object} options
 * @param {string} options.title - Title text
 * @param {string} options.message - Body message
 * @param {string} options.icon - 'success' | 'error' | 'info' | 'warning' | 'question'
 * @param {function} options.onBack - Callback on "Back" button click
 */
const showSuccessAlert = ({ title = "Well done!", message, icon = "success", onBack }) => {
  Swal.fire({
    html: `
      <div class="mt-3">
        <lord-icon
          src="https://cdn.lordicon.com/lupuorrc.json"
          trigger="loop"
          colors="primary:#0ab39c,secondary:#405189"
          style="width:120px;height:120px">
        </lord-icon>
        <div class="mt-4 pt-2 fs-15">
          <h4>${title}</h4>
          <p class="text-muted mx-4 mb-0">${message}</p>
        </div>
      </div>`,
    showCancelButton: true,
    showConfirmButton: false,
    cancelButtonText: "Back",
    buttonsStyling: false,
    showCloseButton: true,
    customClass: {
      cancelButton: 'btn btn-danger w-xs mb-1',
    },
  }).then((result) => {
    if (result.dismiss === Swal.DismissReason.cancel && typeof onBack === "function") {
      onBack(); 
    }
  });
};

export default showSuccessAlert;
